import { TFunction } from "i18next";
import { Attendee } from "../types";

export const getProductsType = (attendee: Attendee, t: TFunction) => {
    const products_type: string[] = [];
    if (attendee.products_type[0]) products_type.push(t('attendee.products_type_stm'));
    if (attendee.products_type[1]) products_type.push(t('attendee.products_type_brand'));
    if (attendee.products_type[2]) products_type.push(t('attendee.products_type_dist'));
    if (products_type.length > 0) {
        return products_type.join(', ');
    } else {
        return null;
    }
};
